import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEye } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import apiUrl from "../../apiUrlConstant";
import TopHeader from "../../layout/TopHeader";
import { ChartPopup } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
var ReactS3Uploader = require("react-s3-uploader");

var today = new Date(),
  date =
    today.getDate() + "/" + today.getMonth() + 1 + "/" + today.getFullYear();

class TerminateLease extends React.Component {
  state = {
    terminationEffectiveDate: new Date(),
    effectiveDate: new Date(),
    redirect: false,
    changeLandlord: false,
    delete: false,
    additionalDetails: [],
    leaseId: this.props.leaseId,
    leaseCode: this.props.leaseCode,
    costCenter: this.props.costCenter,
    fileName: "Termination-Doc.pdf",
    date: "01/01/2022",
    initialValues: {
      landlordId: [],
    },
  };
  style = (feature) => {
    return {
      fillColor: "#ccc",
      weight: 1,
      opacity: 1,
      color: "#003970",
      dashArray: "2",
      fillOpacity: 0.5,
    };
  };
  constructor(props) {
    super(props);
    //this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  componentDidMount() {
    var date = new Date();
    var formatedDate = `${date.getFullYear() + 1
      }-${date.getMonth()}-${date.getDate()}`;
    this.setState({ terminationEffectiveDate: formatedDate }, () => {
      console.log(this.state.terminationEffectiveDate);
    });
    console.log(formatedDate);
  }


  // onUploadError() {
  //   this.setState({
  //     messsagePopup: true,
  //     popupContent: "Something Went Wrong!",
  //   });
  //   console.log("uploading error....");
  //   // alert("Something Went Wrong");
  // }

  hidePopup() {
    this.props.setShow(false);
  }

  changeLandlord = (newValue, existing) => {
    var currentMapping = this.state.currentLandlordMapping;
    currentMapping[existing]['value'] = newValue.value;
    currentMapping[existing]['label'] = newValue.label;
    this.setState({ currentLandlordMapping: currentMapping });
    // console.log(newValue, "newValue");
    // this.state.landloardSelected = [];
    // this.state.initialValues.landlordId = [];
    // for (let i = 0; i < newValue.length; i++) {
    //   this.state.initialValues.landlordId.push(newValue[i].value);
    //   this.state.landloardSelected.push({
    //     value: newValue[i].value,
    //     label: newValue[i].label,
    //   });
    // }
    // this.setState({});
    // console.log(this.state.landloardSelected, "this.state.landloardSelected");
  };

  handleTypeChange = (e) => {
    if (e.target.value !== "landlord_termination") {
      this.setState({
        changeLandlord: false,
        termination_type: e.target.value,
      });
    }
    this.setState({});
    console.log(this.state.termination_type, "termination_type");

    //this.setState({ fruit: e.target.value });
  };

  redirectAfterSave = () => {
    this.setState({ delete: false });
  };

  redirectToTerminate = () => {
    var value = this.state.values;

    this.redirectAfterSave();

    var self = this;
    if (value.termination_type == "landlord_termination") {
      console.log("in if")
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/lease-view/get-lease-landloard-details?leaseId=${this.state.leaseId}`,
        // url: `${apiUrl.apiUrl.url}/lease-view/get-lease-landloard-details?leaseId=${this.state.costCenter}`,
      }).then(function (response) {
        if (response.data.success) {
          self.state.initialValues.landlordId =
            response.data.additionalDetails.landlordIds;
          self.setState({
            changeLandlord: true,
            additionalDetails: response.data.additionalDetails,
            landloardSelected: response.data.additionalDetails.currentLandlord,
            currentLandlordMapping: response.data.additionalDetails.currentLandlordMapping,
          });
        }
      });
    } else {
      console.log("in else")
      this.uploader.uploadFile();
    }
  };

  onUploadFinish = (e) => {
    let fileName =
      fileUploadPath() +
      this.state.leaseId +
      "/" +
      this.state.fileName;
    var initialValuesArr = this.state.initialValues;
    initialValuesArr["document"] = fileName;
    initialValuesArr["effectiveDate"] = this.state.effectiveDate; //initialValuesArr["effectiveDate"];
    initialValuesArr["termination_settlement"] =
      initialValuesArr["termination_settlement"];
    initialValuesArr["termination_type"] = initialValuesArr["termination_type"];
    initialValuesArr["remarks"] = initialValuesArr["remarks"];
    initialValuesArr["landlordId"] = initialValuesArr["landlordId"];
    initialValuesArr['landlordMapping'] = this.state.currentLandlordMapping;
    console.log("here159")
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/terminate-lease?leaseId=${this.state.leaseId}`,
      // url: `${apiUrl.apiUrl.url}/lease-view/terminate-lease?leaseId=${this.state.CostCenter}`,
      data: initialValuesArr,
    }).then(function (response) {
      if (!response.data.success) {
        self.props.setpopupMessageContent("Something went wrong.");
        self.props.setpopupalertMessage(true);
      } else {
        self.hidePopup();
        self.props.setpopupMessageContent("Details Stored successfully.");
        self.props.setpopupalertMessage(true);
        setTimeout(function () {
          self.props.history.push(response.data.link);
        }, 2000);
        if (typeof initialValuesArr["termination_type"] == "undefined" || initialValuesArr["termination_type"] == "" || initialValuesArr["termination_type"] == "normal_termination") {
          self.props.ths.resetCounter();
          self.props.ths.loadLeaseCountStatuswise();
        }
      }
    });
  };
  render() {
    return (
      <div>
        <Formik
          initialValues={
            {
              "leaseRegistrationDate": "26/05/2022"
              //effectiveDate: '02/02/2022'
            }
          }
          //enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values, "valuee....");
            var self = this;
            this.state.initialValues = values;

            console.log(this.state.fileName, "this.state.fileName");


            this.setState({ delete: true, values: values });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            resetForm,
          }) => (
            <Form autoComplete="off" className="customTabs">
              <div className="unitFormContainer amend">
                <div className="container-fluid p-0">
                  <div className="row prospectAccordion">
                    <div className="col-lg-6 offset-lg-3">
                      <div className="tableContainer prospectTable mt-0">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Lease No
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.leaseCode}
                              </td>
                            </tr>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Cost Center
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.costCenter}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inputContainer"></div>
                    </div>
                    <div className="col-lg-12">
                      <div className="tableContainer screens">
                        <Field
                          as="select"
                          name="termination_type"
                          onChange={(e) => {
                            // setTerminationSettlement(
                            //   e.target.value
                            // );                            
                            this.handleTypeChange(e);
                            handleChange(e);
                          }}
                        >
                          {/* //</div>onChange={this.handleTypeChange} */}
                          <option value="normal_termination">
                            Normal Termination
                          </option>
                          <option value="landlord_termination">
                            Change in Landlord Termination
                          </option>
                          <option value="operating_mode_termination">
                            Change in Operating Mode Termination
                          </option>
                        </Field>

                        <table className="table tableSimple tableSimpleWithNoFlex">
                          <thead>
                            <tr>
                              <th>Section</th>
                              <th>Details</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Effective Date of Termination</td>
                              <td>
                                <DatePicker
                                  onChange={(date) =>
                                    this.setState({ effectiveDate: date })
                                  }
                                  //onBlur={this.handleCalenderOnBlur}
                                  dateFormat="dd/MM/yyyy"
                                  //showMonthYearPicker
                                  selected={this.state.effectiveDate}
                                  maxDate={new Date()}
                                //onCalendarClose={this.handleCalenderOnBlur}
                                />
                                {/* <Field
                                  type="text"
                                  name="effectiveDate"
                                  value={this.state.terminationEffectiveDate}
                                  disabled={"true"}
                                  style={{ paddingRight: "0" }}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                /> */}
                              </td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>
                                Enable settlement billing post Termination Date
                              </td>
                              <td>
                                <Field
                                  type="checkbox"
                                  name={`termination_settlement`}
                                  onChange={(e) => {
                                    // setTerminationSettlement(
                                    //   e.target.value
                                    // );
                                    handleChange(e);
                                  }}
                                  className="sameAs"
                                />
                              </td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>Termination Basis Document</td>
                              <td>
                                <ReactS3Uploader
                                  signingUrl={`/site/get-s3signed-url`}
                                  signingUrlMethod="GET"
                                  accept="pdf/*"
                                  s3path={`${fileUploadPath()}${this.state.leaseId}/`}
                                  preprocess={this.onUploadStart}
                                  onSignedUrl={this.onSignedUrl}
                                  onProgress={this.onUploadProgress}
                                  onError={this.onUploadError}
                                  onFinish={this.onUploadFinish}
                                  // signingUrlHeaders={{ additional: headers }}
                                  // signingUrlQueryParams={{
                                  //   additional: query - params,
                                  // }}
                                  signingUrlWithCredentials={false}
                                  uploadRequestHeaders={
                                    {
                                      //"x-amz-acl": "public-read",
                                    }
                                  }
                                  contentDisposition="attachment"
                                  scrubFilename={() => this.state.fileName}
                                  server={`${apiUrl.apiUrl.url}`}
                                  inputRef={(cmp) => (this.uploadInput = cmp)}
                                  autoUpload={false}
                                  ref={(uploader) => {
                                    console.log("uploaded click", uploader);
                                    this.uploader = uploader;
                                  }}
                                />
                              </td>
                              <td>
                                <Field
                                  type="text"
                                  name={`remarks`}
                                  className="sameAs"
                                  onChange={(e) => {
                                    //setRemarks(e.target.value);
                                    handleChange(e);
                                  }}
                                />
                              </td>
                            </tr>
                            {(values.termination_type == "normal_termination" ||
                              typeof values.termination_type == "undefined" ||
                              values.termination_type == "") && (
                                <tr>
                                  <td>
                                    Change unit status to Vacant in Unit Master
                                  </td>
                                  <td>
                                    <Field
                                      type="checkbox"
                                      name={`change_unit_staus`}
                                      className="sameAs"
                                      onChange={(e) => {
                                        //setUnitStatus(e.target.value);
                                        handleChange(e);
                                      }}
                                    />
                                  </td>
                                  <td>-</td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {!this.state.changeLandlord && (
                      <div className="col-lg-12">
                        <button variant="secondary" type="submit">
                          <FontAwesomeIcon icon={faTimes} /> Terminate
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>

        {this.state.changeLandlord && (
          <Formik
            initialValues={
              {
                newLandlords: this.state.currentLandlordMapping
              }
            }
            enableReinitialize
            onSubmit={(values, actions) => {
              console.log(values, "valuee....", this.state.initialValues);
              //var self = this;
              //this.state.initialValues = values;
              this.uploader.uploadFile();
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
              resetForm,
            }) => (
              <Form autoComplete="off" className="customTabs">
                <div className="unitFormContainer amend">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="inputContainer"></div>
                      </div>
                      <div className="col-lg-12">
                        <div className="tableContainer screens">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th>Old Landlord</th>
                                <th>New Landlord</th>
                              </tr>
                            </thead>
                            <tbody>

                              {this.state.additionalDetails.currentLandlord.map((obj) => (
                                <tr>
                                  <td>{obj.label}</td>
                                  <td><Select
                                    className="basic-single custom-select-style"
                                    classNamePrefix="custom-select-style-inner"
                                    name={"newLandlords[" + obj.value + "]"} //`{newLandlords['+ obj.value +']}`
                                    onInputChange={this.handleChange}
                                    onChange={(e) => {
                                      this.changeLandlord(e, obj.value);
                                      //handleChange(e);
                                    }}
                                    value={{
                                      label: this.state.currentLandlordMapping[obj.value]['label'],
                                      value: this.state.currentLandlordMapping[obj.value]['value'],
                                    }}
                                    options={this.state.additionalDetails.landlordList.map(
                                      (item) => ({
                                        label: item.value,
                                        value: item.id,
                                      })
                                    )}
                                  />
                                  </td>
                                </tr>
                              ))}


                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        {/* <Modal.Footer className="justify-content-center"> */}
                        <button variant="secondary" type="submit">
                          <FontAwesomeIcon icon={faEye} /> Change Landlord
                        </button>
                        {/* </Modal.Footer> */}
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}

        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure to delete this item??"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToTerminate}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default withRouter(TerminateLease);
